import { getBorderStyles, getStyles } from '@kubit/web-ui-components/utils/getStyles';
import styled, { css } from 'styled-components';
export const BadgeLogoContainerStyled = styled.div `
  background-image: url(${props => props.logo});
  ${({ sizeStyles }) => getStyles(sizeStyles?.container)}
  ${({ styles }) => getStyles(styles?.container)}
  ${({ styles, $hasBorder }) => $hasBorder
    ? css `
          ${getBorderStyles(styles?.container)}
        `
    : css `
          border: none;
        `}

  ${({ customWidth }) => customWidth &&
    css `
      width: ${customWidth};
    `}

  ${({ customHeight }) => customHeight &&
    css `
      height: ${customHeight};
    `}
`;
//# sourceMappingURL=badgeLogo.styled.js.map